const removeKeys = (obj, keys) => {
  if (!obj) return;
  keys.forEach((key) => {
    if (key in obj) {
      delete obj[key];
    }
  });
};

const removeKeysByPattern = (obj, patterns) => {
  if (!obj) return;
  Object.keys(obj).forEach((key) => {
    if (patterns.some((pattern) => pattern.test(key))) {
      delete obj[key];
    }
  });
};

export const scrubSentryEvent = (event) => {
  if (!event) return event;

  if (event.user) {
    removeKeys(event.user, ["email", "ip_address", "username"]);
  }

  if (event.request) {
    removeKeys(event.request, ["cookies", "data"]);
    if (event.request.headers) {
      removeKeys(event.request.headers, ["cookie", "authorization"]);
    }
  }

  if (event.extra) {
    removeKeysByPattern(event.extra, [/email/i, /student/i, /user/i]);
  }

  if (Array.isArray(event.breadcrumbs)) {
    // Negative lookahead spares already-anonymized fields we intentionally
    // send for correlation (emailHash, userId, studentId, ...).
    const rawPiiPatterns = [/email(?!hash)/i, /student(?!id)/i, /^user$/i];
    event.breadcrumbs.forEach((breadcrumb) => {
      if (breadcrumb?.data) {
        removeKeysByPattern(breadcrumb.data, rawPiiPatterns);
      }
    });
  }

  return event;
};
